const VideoFields = {
  heading: {
    type: "text",
    label: "Heading",
    metadata: {
      source: "manual",
      description: "Section heading above the video (e.g. 'As seen on This Old House')",
      seo: true,
    },
  },
  subheading: {
    type: "text",
    label: "Subheading",
    metadata: {
      source: "manual",
      description: "Optional line under the heading",
      seo: true,
    },
  },
  videoUrl: {
    type: "text",
    label: "YouTube link",
    metadata: {
      source: "manual",
      description: "The video's YouTube link, as copied from YouTube's Share button or the address bar",
      seo: false,
    },
  },
  caption: {
    type: "text",
    label: "Caption",
    metadata: {
      source: "manual",
      description: "Optional line under the video",
      seo: true,
    },
  },
} as const;

export { VideoFields };
